<template>
  <div class="container pb-2">
    <!-- New / Edit (no anwsered) -->
    <div class="mb-2" v-if="!loading && !isFormAnswered">
      <!-- <p class="mb-2">Template: {{ templateName }}</p> -->
      <FormulateForm
        ref="form"
        :key="formRenderKey"
        debounce
        :schema="schema"
        v-model="model"
        @submit="onSubmit"
        @created="onFormReady"
        @failed-validation="onValidate"
        @keydown.native="blockSubmit"
        @wheel.native="blockNumberWheel"
      />
    </div>

    <!-- Answered -->
    <div class="mb-2" v-else>
      <FormulateForm
        ref="form"
        :key="formRenderKey"
        debounce
        :schema="schema"
        v-model="model"
        @submit="onSubmit"
        @created="onFormReady"
        @failed-validation="onValidate"
        @keydown.native="blockSubmit"
        @wheel.native="blockNumberWheel"
      />
    </div>

    <div class="text-center" v-if="loading">
      <b-spinner label="Spinning" variant="primary"></b-spinner>
    </div>
  </div>
</template>

<script>
import axios from "@axios";
import moment from "moment";
import FormNormalizer from "./FormNormalizer.js";
import FileUploadWithPreview from "./FileUploadWithPreview.vue";
import ReviewCommentsWithPreview from "./ReviewCommentsWithPreview.vue";
import SectionGroup from "./SectionGroup.vue";
import FormAnswers from "./FormAnswers.vue";
import { EventBus } from "@/libs/event-bus";
import router from "@/router";
import {
  resolveOperationalSecurityFormConfig,
} from "@/config/operationalSecurityForms";
// import sitrepTemplate from './template_sitrep.json'
// import template_boletin_informativo from './template_boletin_informativo.json'
// import template_correo_informativo from './template_correo_informativo.json'
// import template_flash_informativo from './template_flash_informativo.json'

export default {
  name: "BuildForm",
  components: {
    FormAnswers,
    FileUploadWithPreview,
    ReviewCommentsWithPreview,
    SectionGroup,
  },
  props: {
    templateId: { default: null },
    templateSnapshot: { type: Array, default: () => [] },
    templateSourceIds: { type: Array, default: () => [] },
    evaluationId: { type: [Number, String] },
    data: { type: [Array, Object], default: () => ({}) },
    currentState: { type: String, default: "in_progress" },
    isReviewer: { type: Boolean, default: false },
    isCreateSpecialForms: { type: Boolean, default: false },
    currentSpecialForm: { type: String },
    idFormAnswerOwner: { type: Number, default: 0 },
    idPrefill: { default: null },
    currentFormData: { default: null },
    idUnit: { type: Number },
    unit: { type: Object },
    reference: { type: String },
    eventComment: { type: String },
    anotherFacility: { type: String },
    dataToReplace: { default: null  },
    isFormFromSameUser: { default: true  },
  },
  data() {
    return {
      loading: true,
      templateName: "",
      template: "",
      templateData: [],
      localTemplateId: null,
      localevaluationId: null,
      schema: [],
      model: {},
      formData: null,
      filesData: {}, // { label: [{url, name, raw}] }
      formId: null,
      idTenant: null,
      isFormAnswered: false,
      evaluation: null,
      statuses: [],
      lastStatus: null,
      incomingSnapshot: [],
      incomingSources: [],
      _normalizer: null,
      _syncingSchema: false,
      id_unit: false,
      uploadingFieldLabel: null,
      deletingFieldLabel: null,
      isFirstLoading: true,
      ownerAnswers: {},
      ownerFacilityAnswer: {},
      ownerUserAnswer: {},
      isBauOrIncident: false,
      mailForms: ["SITREP", "Boletín Informativo", "⁠⁠Flash Informativo", "Correo Informativo"],
      VALID_KEYS: ["comentarios", "descripcion", "notas"],
      isBeingSaved: false,
      isSaveRequestPending: false,
      fileFieldNames: {},
      formRenderKey: 0,
      isBeingReloaded: false,
      lastRefreshedStatus: null,
      reloadCooldownActive: false,
      reloadCooldownTimer: null,
    };
  },
  async mounted() {
    if(this.isCreateSpecialForms && this.idFormAnswerOwner) {
      await this.getFormAnswersOwner();
    }
    EventBus.on(`operational_security_reload_forms_and_list`, this.onReloadEvent);
    EventBus.on(`operational_security_change_status_of_form`, this.onChangeStatusOfForm);
    const user = this.$store.getters["user/getUser"];
    // init
    // const isUserSupervisor = this.isSupervisor(user.profile.type);
    // const isMailForm = this.mailForms.includes(this.currentFormData?.template?.name)
    this.lastStatus = this.currentState;
    const hasDifferentUser =
      this.currentFormData?.user &&
      this.currentFormData.user.id !== user.id;
    const isReadOnlyUser = this.template?.read_only_users?.some(u => u.id === user.id)
    const isDifferentOriginUser = !this.isFormFromSameUser;
    // const isMailRestricted = isMailForm && !isUserSupervisor;
    if (hasDifferentUser || isDifferentOriginUser || isReadOnlyUser) {
      this.lastStatus = 'readonly';
    }
    this.localevaluationId = this.evaluationId || null;
    this.incomingSnapshot = Array.isArray(this.templateSnapshot)
      ? this.templateSnapshot
      : [];
    this.incomingSources = Array.isArray(this.templateSourceIds)
      ? this.templateSourceIds
      : [];
    this.id_unit = this.idUnit
    await this.reloadForm();
    this.isFirstLoading = false
    if(this.isCreateSpecialForms && this.idFormAnswerOwner) {
      setTimeout(() => {
        this.replaceFormAnswersOwner();
      }, 500);
    }

    if(router.currentRoute.query.date) {
      this.replaceDate(router.currentRoute.query.date)
    }
    if(router.currentRoute.query.time) {
      this.replaceTime(router.currentRoute.query.time)
    }
  },
  beforeDestroy() {
    EventBus.off(`operational_security_reload_forms_and_list`, this.onReloadEvent);
    EventBus.off(`operational_security_change_status_of_form`);
    if (this.reloadCooldownTimer) {
      clearTimeout(this.reloadCooldownTimer);
    }
  },
  watch: {
    model: {
      deep: true,
      handler() {
        if (this._syncingSchema || this.loading) return;
        this.rebuildDynamicSchema();
      },
    },
    currentState: function (currentState) {
      this.lastStatus = this.currentState;
      if (this.lastRefreshedStatus === currentState) {
        this.lastRefreshedStatus = null;
        return;
      }
      this.lastRefreshedStatus = null;
      if(this.isFirstLoading) return;
      this.reloadForm();
    },
    isFormFromSameUser: function () {
      if(this.isFormFromSameUser) return;
      this.lastStatus = "readonly"
      this.reloadForm();
    },
    uploadingFieldLabel() {
      this.rebuildDynamicSchema();
    },
    deletingFieldLabel() {
      this.rebuildDynamicSchema();
    },
  },
  computed: {
  },
  methods: {
    blockNumberWheel(e) {
      if (e?.target?.type !== 'number') return
      e.target.blur()
    },
    hasBauComplementsQuery() {
      return Object.prototype.hasOwnProperty.call(
        router.currentRoute?.query || {},
        "bau-complements"
      );
    },
    getBauMissingFields() {
      if (!this._normalizer) return [];
      const optionalTypes = ["files_section", "folio", "placeholder", "commands"];
      const answers = this._normalizer.pruneModelInvisible(this.model || {});
      const { order, groups } = this._normalizer.groupBySection(
        this._normalizer.getProcessedFields()
      );
      const hasValue = (v) => {
        if (v === undefined || v === null) return false;
        if (typeof v === "object") return hasValue(v.value ?? v.id ?? v.label);
        return String(v).trim() !== "";
      };
      const rowGroupTypes = ["facilities", "users", "rhUsers"];
      const missing = [];

      order.forEach((secName) => {
        const secFields = (groups.get(secName) || {}).fields || [];
        secFields.forEach((field, idx) => {
          if (optionalTypes.includes(field.type)) return;
          if (!this._normalizer.isFieldVisible(field, secFields, idx, answers)) return;

          let answered;
          if (rowGroupTypes.includes(field.type)) {
            const value = answers[field.name];
            const rows = Array.isArray(value) ? value : [{ [field.name]: value }];
            answered = rows.some((row) =>
              row && (row.isAnotherFacility
                ? hasValue(row.anotherFacility)
                : hasValue(row[field.name]) || hasValue(row[`${field.name} [id]`]))
            );
          } else {
            answered = this._normalizer.isFieldAnswered(field, answers);
          }
          if (!answered) missing.push(this._normalizer.buildLabel(field));
        });
      });

      return missing;
    },
    blockSubmit(e) {
      const isNotTextArea = e.key === 'Enter' && e?.target?.tagName !== 'TEXTAREA'
      if (isNotTextArea) {
        e.preventDefault()
        return;
      }

      if (e.key === 'Dead') {
        e.preventDefault()
        return
      }

      const isNumberInput = e?.target?.type === 'number'
      if (!isNumberInput) return
      const allowedKeys = [
        'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
      ]
      const isDigit = /^\d$/.test(e.key)
      if (!isDigit && !allowedKeys.includes(e.key)) {
        e.preventDefault()
      }
    },
    isSupervisor(profile) {
      const p = profile.toLowerCase()
      return p.includes('supervisor') || p.includes('masteradmin')
    },
    onReloadEvent(options = {}) {
      if (options?.skipFormReload) return;
      if(!this.localevaluationId) return;
      this.reloadForm();
    },
    onChangeStatusOfForm() {
      this.onSubmit();
    },
    onFormReady() {},
    onValidate() {},
    submitForm() {
      try {
        const formRef = this.$refs && this.$refs.form ? this.$refs.form : null;
        if (formRef && typeof formRef.submit === "function") {
          formRef.submit();
          return;
        }
      } catch (e) {}

      try {
        const el = this.$refs && this.$refs.form && this.$refs.form.$el ? this.$refs.form.$el : null;
        if (el) {
          const evt = new Event("submit", { cancelable: true });
          el.dispatchEvent(evt);
          return;
        }
      } catch (e) {}

      try { this.onSubmit(); } catch (e) {}
    },
    isFacilityAnswer(value) {
      return Array.isArray(value) &&
      value.some(obj =>
        obj && typeof obj === 'object' &&
        Object.keys(obj).some(key => key.includes('[Estado]'))
      );
    },
    isUserAnswer(value) {
      return Array.isArray(value) &&
      value.some(obj =>
        obj && typeof obj === 'object' &&
        Object.keys(obj).some(key => key.includes('[SOEID]'))
      );
    },
    async getFormAnswersOwner() {
      const {data} = await axios.get(
        `/v1/operational-security-forms/template-answers/display-form/${this.idFormAnswerOwner}?raw_answers=true&format=kvalues`
      );
      this.ownerAnswers = data.data;
      for (const [key, value] of Object.entries(this.ownerAnswers)) {
        const userAnswer = this.isUserAnswer(value)
        const facilityAnswer = this.isFacilityAnswer(value)
        if(userAnswer) this.ownerUserAnswer = value
        if(facilityAnswer) this.ownerFacilityAnswer = value
      }
    },
    async replaceFormAnswersOwner() {
      this.model = {...this.model, ...this.ownerAnswers}
      this.injectCommentIntoChild(this.ownerAnswers)
      const titulo = this.getAnswer(this.ownerAnswers, "titulo");
      if(titulo) {
        this.replaceTitleQuestion(titulo)
      }
      for (const [key, value] of Object.entries(this.ownerAnswers)) {
        this.replaceFacility(value);
        this.replaceUsers(value);
        this.replaceSingleQuestions(key, value);
        if(this.isTime(value)) this.replaceTime(value)
        if(this.isDate(value)) this.replaceDate(value)
      }
      this.replaceFiles()
    },
    normalizeKey(str) {
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    },
    getParentCommentValue(parent) {
      for (const key of Object.keys(parent)) {
        const normalized = this.normalizeKey(key);
        if (this.VALID_KEYS.includes(normalized)) {
          return parent[key];
        }
      }
      return null;
    },
    injectCommentIntoChild(parent) {
      const valueToInject = this.getParentCommentValue(parent);
      if (!valueToInject) return;

      const childCommentQuestion = this.templateData.filter(q => {
        const normalized = this.normalizeKey(q.name);
        if (this.VALID_KEYS.includes(normalized)) {
          return q
        }
      });
      if(!childCommentQuestion[0]?.name) return;

      this.model[childCommentQuestion[0].name] = valueToInject;
    },
    getAnswer(obj, key) {
      const normalizedKey = key
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();

      return Object.entries(obj).find(([k]) =>
        k.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase() === normalizedKey
      )?.[1];
    },
    isTime(value) {
      if (typeof value !== 'string') return false;
      // HH:mm or HH:mm:ss
      return /^([01]\d|2[0-3]):([0-5]\d)(:([0-5]\d))?$/.test(value.trim());
    },
    isDate(value) {
      if (typeof value !== 'string') return false;
      const v = value.trim();
      const patterns = [
        /^([0-2]\d|3[01])\/(0\d|1[0-2])\/(\d{4})$/, // d/m/Y
        /^([0-2]\d|3[01])\/(0\d|1[0-2])\/(\d{2})$/, // d/m/y
        /^([0-2]\d|3[01])-(0\d|1[0-2])-(\d{4})$/, // d-m/Y
        /^([0-2]\d|3[01])-(0\d|1[0-2])-(\d{2})$/  // d-m/y
      ];

      return patterns.some(rx => rx.test(v));
    },
    replaceDate(value) {
      const dateQuestions = this.templateData.filter(ques => ques?.type === 'date')
      dateQuestions.forEach(timeQuestion => {
        if(timeQuestion?.name && value) {
          this.model[timeQuestion.name] = value
        };
      });
    },
    replaceTime(value) {
      const timeQuestions = this.templateData.filter(ques => ques?.type === 'time')
      timeQuestions.forEach(timeQuestion => {
        if(timeQuestion?.name && value) {
          this.model[timeQuestion.name] = value
        };
      });
    },
    replaceFiles() {
      const filesQuestion = this.templateData.find(ques => ques?.type === 'files_section')
      const dataToReplace = this.dataToReplace?.archivos
      if(filesQuestion?.name && dataToReplace) {
        this.filesData[filesQuestion.name] = (dataToReplace || []).map((file) => ({
          url: file.url || "",
          name: file.name,
          raw: file.raw || null,
        }));
      };
    },
    replaceUsers(value) {
      const usersQuestion = this.templateData.find(ques => ques?.type === 'users')
      if(this.isUserAnswer(value) && usersQuestion?.name) {
        const userData = !usersQuestion.options?.isGroup && value.length > 1
          ? value.slice(0, 1)
          : value;
        this.model[usersQuestion.name] = userData.map(obj => {
          const newObj = {};
          const firstKey = Object.keys(obj)[0];
          const oldName = firstKey.split(' [')[0];
          for (const [key, val] of Object.entries(obj)) {
            const updatedKey = key.replace(oldName, usersQuestion.name);
            newObj[updatedKey] = val;
          }
          return newObj;
        });
      }
    },
    replaceSingleQuestions(key, value) {
      const [main] = key.split("|");
      const normalized = s => s.normalize("NFD").replace(/[\u0300-\u036f]/g, '').toLowerCase();
      if (["categoria", "clasificacion", "comentarios","Tipo de evento", "subcategoria"].includes(normalized(main))) {
        const keyTarget = Object.keys(this.model).find(k => normalized(k).startsWith(normalized(main)));
        if(normalized(main) === "clasificacion") {
          if ('Tipo de incidente' in this.model) {
            this.model['Tipo de incidente'] = value
          }
        }
        if (keyTarget && keyTarget in this.model) {
          if(normalized(main) === "categoria") {
            this.replacCatQuestion(normalized, value);
            return;
          }
          if(normalized(main) === "subcategoria") {
            this.replacSubCatQuestion(normalized, value);
            return;
          }
          if(normalized(main) === "clasificacion") {
            if ('Tipo de incidente' in this.model) {
              this.model['Tipo de incidente'] = value
            }
            this.replaceTitleQuestion(value)
          }
          this.model[keyTarget] = value;
        }
      }
    },
    replacSubCatQuestion(normalized, value) {
      setTimeout(() => {
        const classKey = Object.keys(this.model).find(k => normalized(k).startsWith(normalized("Clasificación")));
        const catKey = Object.keys(this.model).find(k => normalized(k).startsWith(normalized("Categoría")));
        const eventType = this.model["Tipo de evento"];
        let subCat = `Subcategoría|${this.model[classKey]}/${this.model[catKey]}`;
        if(eventType !== "BAU") {
          subCat = `Subcategoría|Incidente/${this.model[classKey]}/${this.model[catKey]}`;
        }
        this.model[subCat] = value;
      }, 200);
    },
    keyToLowerCase (str) {
      const parts = str.split(" ");
      if (parts.length > 2) {
        parts[2] = parts[2][0].toLowerCase() + parts[2].slice(1);
      }
      return parts.join(" ");
    },
    replacCatQuestion(normalized, value) {
      const classKey = Object.keys(this.model).find(k => normalized(k).startsWith(normalized("Clasificación")));
      let eventType = this.model["Tipo de evento"];
      if(eventType === "Incidente") eventType = "Incidentes"
      const catKey = `Categoría|${eventType}/${this.model[classKey]}`
      this.model[catKey] = value;
    },
    replaceTitleQuestion(value) {
      this.model["Título"] = value;
    },
    replaceFacility(value) {
      const facilityQuestion = this.templateData.find(ques => ques?.type === 'facilities')
      if(this.isFacilityAnswer(value) && facilityQuestion?.name) {
        const TAG_TO_KEY = {
          'Categorías': 'categories',
          'Estado': 'region',
          'Subregión': 'subregion',
          'SIRH': 'sirh',
          'Municipio': 'municipality',
          'REMS': 'rems',
          'ID SEPROBAN': 'id_seproban',
          'Lat': 'lat',
          'Lng': 'lng',
        }
        const facilityData = !facilityQuestion.options?.isGroup && value.length > 1
          ? value.slice(0, 1)
          : value;
        const extraFieldsDefault = {
          categories: true,
          region: true,
          subregion: true,
          sirh: true,
          municipality: true,
          rems: true,
          id_seproban: true,
          lat: true,
          lng: true,
        }
        const extraFieldsConf = facilityQuestion.options?.fieldTypeCfg?.data[0] ?? extraFieldsDefault;
        this.model[facilityQuestion.name] = []
        this.model[facilityQuestion.name] = facilityData.map(obj => {
          const newObj = {}
          const firstKey = Object.keys(obj).find(key => key.includes('['))
          const oldName = firstKey.split(' [')[0]
          for (const [key, val] of Object.entries(obj)) {
            const tag = this.extractTag(key)
            if(key === "isAnotherFacility" || key === "anotherFacility") {
              newObj[key] = val;
              continue;
            }
            if (!tag && (key !== "isAnotherFacility" || key !== "anotherFacility")) {
              newObj[key.replace(oldName, facilityQuestion.name)] = val
              continue
            }
            const cfgKey = TAG_TO_KEY[tag]
            if (cfgKey && extraFieldsConf[cfgKey] === true) {
              const updatedKey = key.replace(oldName, facilityQuestion.name)
              newObj[updatedKey] = val
            }
          }

          return newObj
        })
      }
    },
    async checkIfFormExists() {
      return axios.get(
        `/v1/operational-security-forms/template-answers/${this.localevaluationId}?withData=true&withValidation=true`
      );
    },
    extractTag(key) {
      const match = key.match(/\[(.+?)\]/)
      return match ? match[1] : null
    },
    setSaveButton() {
      this.$nextTick(() => {
        const formRef = this.$refs.form.$el;
        const finishId = '#save-op-sec-form'
        const validateBtn = formRef.querySelector(finishId);
        if (validateBtn) {
          const newBtn = validateBtn.cloneNode(true);
          validateBtn.parentNode.replaceChild(newBtn, validateBtn);
          newBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.requestFormSave();
          });
        }

        const reloadBtn = formRef.querySelector('#reload-op-sec-form');
        if (reloadBtn) {
          const newBtn = reloadBtn.cloneNode(true);
          reloadBtn.parentNode.replaceChild(newBtn, reloadBtn);
          newBtn.disabled = this.isReloadButtonDisabled();
          newBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.requestFormReload();
          });
        }
      });
    },

    getReloadButtonConfig() {
      const formConfig = resolveOperationalSecurityFormConfig(
        this.templateName || this.template?.name
      );
      return formConfig.reloadButton;
    },

    isReloadButtonDisabled() {
      return (
        this.reloadCooldownActive ||
        this.isBeingSaved ||
        this.isSaveRequestPending ||
        this.isBeingReloaded
      );
    },

    syncReloadButtonDisabledState() {
      const button = this.$refs?.form?.$el?.querySelector('#reload-op-sec-form');
      if (button) button.disabled = this.isReloadButtonDisabled();
    },

    startReloadCooldown() {
      const { cooldownMs } = this.getReloadButtonConfig();
      const duration = Math.max(0, Number(cooldownMs) || 0);

      if (this.reloadCooldownTimer) {
        clearTimeout(this.reloadCooldownTimer);
      }

      this.reloadCooldownActive = duration > 0;
      this.syncReloadButtonDisabledState();
      if (!duration) return;

      this.reloadCooldownTimer = setTimeout(() => {
        this.reloadCooldownActive = false;
        this.reloadCooldownTimer = null;
        this.syncReloadButtonDisabledState();
      }, duration);
    },

    async requestFormReload() {
      if (this.isReloadButtonDisabled()) return;
      this.startReloadCooldown();
      this.isBeingReloaded = true;
      this.syncReloadButtonDisabledState();

      try {
        await this.reloadForm();
      } finally {
        this.isBeingReloaded = false;
        this.syncReloadButtonDisabledState();
      }
    },

    async requestFormSave() {
      if (this.isBeingSaved || this.isSaveRequestPending || this.isBeingReloaded) return;
      this.isSaveRequestPending = true;
      this.syncReloadButtonDisabledState();

      try {
        if (this.hasBauComplementsQuery()) {
          await this.onSubmit();
          return;
        }
        if(!this.template.allow_draft) {
          await this.$refs.form.formSubmitted();
          return;
        }
        await this.onSubmit();
      } finally {
        this.isSaveRequestPending = false;
        this.syncReloadButtonDisabledState();
      }
    },
    async reloadForm() {
      this.loading = true;
      this.localTemplateId = this.templateId;

      try {
        if (!this.localevaluationId && this.evaluationId) {
          this.localevaluationId = this.evaluationId;
        }

        if (!this.localevaluationId) {
          await this.fetchTemplateOnlyOrSnapshot();
        } else {
          const resp = await this.checkIfFormExists();
          const formData = resp.data;
          const templateId = formData.id_template || this.localTemplateId;
          const { data: template } = await axios.get(
            `/v1/operational-security-forms/templates/${templateId}`
          );
          this.applyLoadedForm(formData, template);
        }
      } catch (error) {
        console.error("Error fetching form:", error);
        this.formId = null;
        this.isFormAnswered = false;
      }

      this.initializeFormNormalizer();
      // this.rebuildDynamicSchema();
      this.loading = false;
      this.setSaveButton();
    },

    applyLoadedForm(formData, template) {
      this.formId = formData.id || null;
      this.model = formData.data || {};
      this.formData = formData;
      this.localTemplateId = formData.id_template || this.localTemplateId;
      this.id_unit = formData.id_unit;
      this.templateName = template.name;
      this.templateData = template.data;
      this.template = template;
      this.isBauOrIncident =
        template.name === "Atención diaria BAU" ||
        template.name === "Atención diaria INCIDENTES";
      this.$emit("onAfterGetTemplate", formData, template);
      this.setStatusOfForm(formData);
      this.isFormAnswered = true;
    },

    async refreshSavedForm(fallbackData) {
      try {
        const response = await this.checkIfFormExists();
        const formData = response.data;
        const templateId = formData.id_template || this.localTemplateId;
        const { data: template } = await axios.get(
          `/v1/operational-security-forms/templates/${templateId}`
        );

        this.applyLoadedForm(formData, template);
        this.initializeFormNormalizer();
        this.setSaveButton();
        this.lastRefreshedStatus = formData.status;

        return formData;
      } catch (error) {
        console.error("Error refreshing saved form:", error);
        return fallbackData;
      }
    },

    async fetchTemplateOnlyOrSnapshot() {
      if (!this.localTemplateId) {
        this.templateData = [];
        this.model = {};
        return;
      }

      const { data } = await axios.get(`/v1/operational-security-forms/templates/${this.localTemplateId}`);
      this.templateName = data.name;
      this.templateData = data.data;
      this.template = data;
      // this.templateData = sitrepTemplate;
      this.model = {};
       this.isBauOrIncident = data.name === "Atención diaria BAU" || data.name === "Atención diaria INCIDENTES"
      this.$emit("onAfterGetTemplate", null, data);
    },

    setStatusOfForm(formData) {
      const user = this.$store.getters["user/getUser"];
      this.evaluation = formData.evaluation || null;
      this.lastStatus = this.lastStatus === 'readonly' ? this.lastStatus : formData.status
      // this can be change, the way to validate if is analiyst
      const isAnalyst =
        user?.profile?.type?.toLowerCase().includes("analista_");
      if (formData?.status === "rejected" && isAnalyst) {
        this.lastStatus = "in_progress";
      }
    },

    normalizeText(text) {
      return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    },

    resolveCommandFacilityId() {
      if (this.formData) {
        return this.id_unit || this.formData?.unit?.id || null;
      }

      return this.id_unit || this.unit?.id || null;
    },

    initializeFormNormalizer() {
      const user = this.$store.getters["user/getUser"];
      const isReadOnlyUser = this.template?.read_only_users?.some(u => u.id === user.id)
      if(isReadOnlyUser) {
        this.lastStatus = 'readonly';
      }
      const effectiveState = this.lastStatus;
      const reloadButton = this.getReloadButtonConfig();

      this._normalizer = new FormNormalizer(this, this.templateData, {
        disabled: false,
        currentState: effectiveState,
        isReviewer: this.isReviewer === true,
        customComponents: {
          FileUploadWithPreview,
          ReviewCommentsWithPreview,
          SectionGroup,
        },
        model: this.model,
        onUpdateFiles: this.handleFileUpload,
        onUpdateComments: ({ label, comments }) => {
          this.$set(this.model, label, comments || []);
        },
        extraData: {
          unit: this.unit,
          eventComment: this.eventComment,
          formId: this.formId,
          userAnswer: this.ownerUserAnswer,
          facilityAnswer: this.ownerFacilityAnswer,
          files: this.dataToReplace?.archivos,
        },
        uploadingFieldLabel: this.uploadingFieldLabel,
        deletingFieldLabel: this.deletingFieldLabel,
        template: this.template,
        formId: this.formId,
        facilityId: this.resolveCommandFacilityId(),
        onCommandFinished: this.onCommandFinished,
        reloadButton: {
          ...reloadButton,
          disabled: this.isReloadButtonDisabled(),
        },
      });
      this.schema = this._normalizer.convert();
    },

    async onCommandFinished({ fieldName, result }) {
      if (fieldName) this.$set(this.model, fieldName, result);

      await this.refreshSavedForm(this.formData);

      if (fieldName && !this.model[fieldName]) {
        this.$set(this.model, fieldName, result);
        this.rebuildDynamicSchema();
      }

      EventBus.emit("operational_security_reload_forms_and_list", {
        skipFormReload: true,
      });
    },

    rebuildDynamicSchema() {
      if (!this._normalizer) return;
      this._syncingSchema = true;
      if (this._normalizer.options) {
        this._normalizer.options.uploadingFieldLabel = this.uploadingFieldLabel;
        this._normalizer.options.deletingFieldLabel = this.deletingFieldLabel;
      }
      try {
        this._normalizer.model = this.model || {};
        const pruned = this._normalizer.pruneModelInvisible(this.model || {});
        if (JSON.stringify(pruned) !== JSON.stringify(this.model || {})) {
          this.model = pruned;
        }
        this.schema = this._normalizer.convert();
      } finally {
        this.$nextTick(() => {
          this._syncingSchema = false;
        });
      }
    },

    handleFileUpload({ files, label, name: fieldName }) {
      this.fileFieldNames[label] = fieldName;
      const previousLength = (this.filesData[label] || []).length;
      if (!this.filesData[label]) this.$set(this.filesData, label, []);
      this.filesData[label] = (files || []).map((file) => ({
        url: file.url || "",
        name: file.name,
        raw: file.raw || null,
      }));

      const hasRawFiles = (files || []).some((f) => f && f.raw);
      if (hasRawFiles) {
        this.uploadingFieldLabel = label;
        this.uploadFilesForField(label, this.filesData[label], fieldName);
        return;
      }

      const newLength = (files || []).length;
      if (newLength < previousLength) {
        this.deletingFieldLabel = label;
        this.uploadFilesForField(label, this.filesData[label], fieldName);
      }
    },

    async uploadFilesForField(label, files, fieldName) {
      if (!this.ensureEvaluationId()) {
        this.uploadingFieldLabel = null;
        this.deletingFieldLabel = null;
        // this.$toast?.error?.(this.$t?.("risk.missing_evaluation") || "Missing evaluation id");
        return;
      }

      const formData = this._buildFormDataForField(label, files);
      const url = this.formId
        ? `v1/operational-security-forms/template-answers/${this.formId}?uploading-files=true`
        : `v1/operational-security-forms/template-answers`;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-HTTP-Method-Override": this.formId ? "PUT" : "POST",
        },
      };

      try {
        const response = await axios.post(url, formData, config);
        const payload = response.data?.data ?? response.data;
        if (payload && payload.id) {
          this.formId = payload.id;
          this.localevaluationId = payload.id;
        }
        const savedData = payload?.data ?? response.data?.data?.data ?? response.data?.data;
        this.applySavedFileList(label, fieldName, savedData);
      } catch (error) {
        if (this.hasBauComplementsQuery()) {
          this.$set(this.filesData, label, (this.filesData[label] || []).filter((f) => !f.raw));
        }
        this.$toast?.error?.(this.$t?.("risk.save_failed") || "No se pudo guardar");
        this.$emit("submitError", { error });
      } finally {
        this.uploadingFieldLabel = null;
        this.deletingFieldLabel = null;
      }
    },

    applySavedFileList(label, fieldName, savedData) {
      const fileListRaw = (savedData && Array.isArray(savedData[label])) ? savedData[label] : (fieldName && savedData && Array.isArray(savedData[fieldName]) ? savedData[fieldName] : null);
      if (!fileListRaw) return false;
      const fileList = fileListRaw.map((f) => ({
        url: f.url || "",
        name: f.name || "",
        raw: null,
      }));
      this.$set(this.filesData, label, fileList);
      const modelKey = fieldName != null ? fieldName : label;
      this.$set(this.model, modelKey, fileList);
      return true;
    },

    _buildFormDataForField(fieldLabel, allFiles) {
      const formData = new FormData();
      const baseline = this._normalizer
        ? this._normalizer.pruneModelInvisible(this.model || {})
        : { ...this.model };
      const fileListForData = (allFiles || []).map((f) => ({
        url: f.raw ? "" : (f.url || ""),
        name: f.name || "",
      }));
      const finalData = { ...baseline, [fieldLabel]: fileListForData };

      for (const file of allFiles || []) {
        if (file.raw) formData.append(`${fieldLabel}[]`, file.raw);
      }

      if (this.localTemplateId) formData.append("id_template", this.localTemplateId);
      if (this.reference) formData.append("reference", this.reference);
      if (this.idPrefill) formData.append("id_prefill", this.idPrefill);
      if (this.id_unit) formData.append("id_unit", this.id_unit);
      if (this.idFormAnswerOwner && !this.idPrefill) formData.append("id_form_answer_owner", this.idFormAnswerOwner);
      if (this.anotherFacility) formData.append("inmueble_otro", this.anotherFacility);
      finalData.__meta = {
        all_required_answered: this._normalizer
          ? this._normalizer.computeAllRequiredAnswered(finalData)
          : false,
      };
      formData.append("data", JSON.stringify(finalData));
      return formData;
    },

    async convertUrlToBlob(url) {
      try {
        const response = await fetch(url);
        if (!response.ok)
          throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
        return await response.blob();
      } catch (error) {
        console.error("Error converting URL to Blob:", error);
        return null;
      }
    },

    ensureEvaluationId() {
      if (!this.localevaluationId) {
        this.localevaluationId =
          this.evaluationId ||
          this.formData?.id_evaluation ||
          this.evaluation?.id ||
          null;
      }
      return !!this.localevaluationId;
    },

    async validateAndSubmit() {
      const isValid = await this.$refs.form.formSubmitted();
      return isValid;
    },

    async onSubmit() {
      if(this.isBeingSaved) return { success: false, skipped: true, data: null, error: null };
      const isBauForm = this.hasBauComplementsQuery();
      this.loading = true;
      this.isBeingSaved = true;
      this.syncReloadButtonDisabledState();

      const baseline = this._normalizer
        ? this._normalizer.pruneModelInvisible(this.model || {})
        : this.model || {};
      const finalData = { ...baseline };
      const formData = new FormData();

      const visibleFileLabels = this._normalizer
        ? this._normalizer.visibleFileLabels(this.model || {})
        : new Set();

      for (const fieldName in this.filesData) {
        if (fieldName.startsWith("review_comments_")) continue;
        if (visibleFileLabels.size && !visibleFileLabels.has(fieldName)) continue;

        const allFiles = this.filesData[fieldName] || [];
        finalData[fieldName] = allFiles
          .filter((file) => !isBauForm || file.url)
          .map((file) => ({
            url: file.url || "",
            name: file.name,
          }));

        for (const file of allFiles) {
          if (file.raw) {
            formData.append(`${fieldName}[]`, file.raw);
          } else if (file.url) {
            const blob = await this.convertUrlToBlob(file.url);
            if (blob) formData.append(`${fieldName}[]`, blob, file.name);
          }
        }
      }

      const reviewKeys = Object.keys(this.model).filter((k) =>
        k.startsWith("review_comments_")
      );
      reviewKeys.forEach((rk) => {
        const commentsArr = Array.isArray(this.model[rk]) ? this.model[rk] : [];
        finalData[rk] = commentsArr.map((c) => ({
          text: c.text,
          date: c.date,
          user: c.user,
          files: Array.isArray(c.files)
            ? c.files.map((f) => ({
                url: (f.url && !String(f.url).startsWith("blob:")) ? f.url : "",
                name: f.name,
              }))
            : [],
        }));
        commentsArr.forEach((comment, cIdx) => {
          const files = Array.isArray(comment.files) ? comment.files : [];
          files.forEach((fObj) => {
            let fileToSend = null;
            if (fObj.raw instanceof File || fObj.raw instanceof Blob) {
              fileToSend = fObj.raw;
            } else if (fObj instanceof File || fObj instanceof Blob) {
              fileToSend = fObj;
            } else if (fObj.file && (fObj.file instanceof File || fObj.file instanceof Blob)) {
              fileToSend = fObj.file;
            } else if (fObj.originFileObj && (fObj.originFileObj instanceof File || fObj.originFileObj instanceof Blob)) {
              fileToSend = fObj.originFileObj;
            }
            const needsAppend = !fObj.url || fObj.url.trim() === "" || String(fObj.url || "").startsWith("blob:");
            if (fileToSend && needsAppend) {
              formData.append(`${rk}[${cIdx}][files][]`, fileToSend);
            }
          });
        });
      });
      // const isMakerCheckerFlow = this.template.maker_checker_flow ?? true;
      if (this.localTemplateId) formData.append("id_template", this.localTemplateId);
      if (this.reference && this.templateData.name !== "SITREP") formData.append("reference", this.reference);
      if (this.idPrefill) formData.append("id_prefill", this.idPrefill);
      if (this.id_unit) formData.append("id_unit", this.id_unit);
      if (this.idFormAnswerOwner && !this.idPrefill) formData.append("id_form_answer_owner", this.idFormAnswerOwner);
      if (this.anotherFacility) formData.append("inmueble_otro", this.anotherFacility);

      // id_alarm is present in the url as a query param
      if (router.currentRoute.query.id_alarm) {
        formData.append('id_alarm', router.currentRoute.query.id_alarm);
      }

      finalData.__meta = {
        all_required_answered: this._normalizer
          ? this._normalizer.computeAllRequiredAnswered(finalData)
          : false,
      };

      formData.append("data", JSON.stringify(finalData));

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-HTTP-Method-Override": this.formId ? "PUT" : "POST",
        },
      };

      const labelsWithPendingFiles = isBauForm
        ? Object.keys(this.filesData).filter((label) =>
            (this.filesData[label] || []).some((file) => file.raw)
          )
        : [];

      try {
        const url = this.formId
          ? `v1/operational-security-forms/template-answers/${this.formId}`
          : `v1/operational-security-forms/template-answers`;
        const data = await axios.post(url, formData, config);
        this.formId = data.data.id
        this._normalizer.formId = data.data.id;
        this.localevaluationId = data.data.id
        this.lastStatus = data.data.status

        if (labelsWithPendingFiles.length) {
          labelsWithPendingFiles.forEach((label) =>
            this.applySavedFileList(label, this.fileFieldNames[label], data.data?.data)
          );
          this.formRenderKey++;
        }

        const formConfig = resolveOperationalSecurityFormConfig(
          data.data?.template?.name || this.templateName
        );
        let submittedData = data.data;

        if (formConfig.refreshAfterSave) {
          submittedData = await this.refreshSavedForm(data.data);
          EventBus.emit("operational_security_reload_forms_and_list", {
            skipFormReload: true,
          });
        } else {
          this.rebuildDynamicSchema()
        }

        this.$emit("submit", submittedData);
        return { success: true, skipped: false, data: submittedData, error: null };
      } catch (error) {
        this.$emit("submitError", { error });
        return { success: false, skipped: false, data: null, error };
      } finally {
        this.loading = false;
        this.isBeingSaved = false;
        this.syncReloadButtonDisabledState();
      }
    },

    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>

<style>
.preview-container {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.preview-image {
  max-width: 100px;
  max-height: 100px;
  margin-right: 10px;
  cursor: pointer;
}
[dir=ltr] .v-select:not(.vs--single) .vs__selected {
  background-color: var(--primary)!important;
}
</style>
